// extracted by mini-css-extract-plugin
export default {"modal":"Nka-z","header":"Oka-z","fields":"Pka-z","error":"Qka-z","disabled":"Rka-z","reminderMsg":"Ska-z","errorMsg":"Tka-z","footer":"Uka-z"};